import { confirmPasswordReset, signInWithEmailAndPassword, signOut, type Auth } from 'firebase/auth';

/** Confirms a password reset and signs in as that account — clearing out any
 *  pre-existing session first. Without the signOut, a different account still
 *  active in this browser can remain the shared "current user" and reappear
 *  on refresh instead of the account whose password was just reset. */
export async function resetPasswordAndSignIn(
  auth: Auth,
  oobCode: string,
  password: string,
  email: string,
): Promise<void> {
  await signOut(auth).catch(() => {});
  await confirmPasswordReset(auth, oobCode, password);
  await signInWithEmailAndPassword(auth, email, password);
}
